import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'es' ? 'en' : 'es';
        i18n.changeLanguage(newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className="p-2 text-slate-600 hover:text-blue-600 hover:bg-slate-100 rounded-full transition-colors flex items-center gap-2"
            aria-label="Switch language"
            title={i18n.language === 'es' ? 'Switch to English' : 'Cambiar a Español'}
        >
            <Globe size={20} />
            <span className="text-sm font-medium uppercase">{i18n.language}</span>
        </button>
    );
};
